<!-- <div id="global-header">
    <div class="ahe-ui-navbar navbar" role="navigation" id="top1">
        <div class="ahe-ui-navbar navbar-brand">
            <img [src]="assestsUrl" title="MHE Logo" alt="MHE Logo">
        </div>
    </div>
</div> -->
<header class="ahe-ui-navbar navbar learning-dark app-header">
  <div role="img" aria-label="McGraw Hill logo" class="header-wrapper logo"></div>
</header>
